<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_Log')"
      width="655px"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row row-grid" style="padding: 0;">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'360px'}"
        />
      </div>
      <div slot="footer">
        <el-button @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { queryOplogList } from '@/api/price/openPrice'

export default {
  name: 'OpenPriceOplogDialog',
  props: {
    visible: { type: Boolean, required: true },
    filingBatchNo: { type: String, default: '' } // 备案批次号
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Time'), colId: 'opDate', field: 'opDate', initialWidth: 140, minWidth: 140, sortable: false,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'), colId: 'opBy', field: 'opBy', initialWidth: 120, minWidth: 120, sortable: false,
          headerClass: 'ag-header-cell-center', cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => {
            if (!params.value) {
              return 'RPA'
            } else {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Content'), colId: 'message', field: 'message', initialWidth: 350, minWidth: 350, sortable: false
        }
      ],
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (!this.filingBatchNo) {
        return
      }
      this.loading = getLoading()
      queryOplogList({ filingBatchNo: this.filingBatchNo }).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>
